import { render, staticRenderFns } from "./PostJobLimitError.vue?vue&type=template&id=10af169a&scoped=true"
import script from "./PostJobLimitError.vue?vue&type=script&lang=ts"
export * from "./PostJobLimitError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10af169a",
  null
  
)

export default component.exports